module.exports = __webpack_public_path__ + "img/pcn-home-banner.d58ba1b8.png";